<div
    skeletonScreen
    [showSkeleton]="isLoading"
    class="header-container mat-card"
>
    <div
        class="logo-wrapper"
        [ngClass]="{ 'logo-background-off': settings?.logo && !isFailedLogo }"
        skeletonData
        [showSkeleton]="isLoading || !isLogoReady"
        [placeholderHeight]="'100%'"
    >
        <img
            *ngIf="settings?.logo"
            [src]="settings.logo"
            (load)="logoIsReady()"
            (error)="failLogo()"
            onerror="this.src = 'assets/images/gift.png'"
        />
        <img
            *ngIf="!settings?.logo"
            [src]="'assets/images/gift.png'"
            (load)="logoIsReady()"
        />
    </div>
    <div *ngIf="settings || isLoading" class="title-container">
        <div
            class="header-title"
            skeletonData
            [placeholderHeight]="'1rem'"
            [placeholderWidth]="'24rem'"
            qa="online-store-title"
        >
            {{ settings?.headerTitle }}
        </div>
        <div
            class="header-sub-title"
            skeletonData
            [placeholderHeight]="'1rem'"
            [placeholderWidth]="'24rem'"
        >
            {{ settings?.headerSubTitle }}
        </div>
    </div>
</div>
